import { ACTIVE_ITEMS } from '@constants/activeItems';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { LIMIT_ITEMS_SELECT } from '../../../../@constants/Pagination';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const SegmentMarketField: FC<{
  value: number[] | null;
  onChange: (value: number[] | null) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation('reservation');

  const {
    ChainApi: { settings: SettingsService },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['get-segment-market-codes'],
    queryFn: () => {
      return SettingsService.reservation.segmentMarketCode.getAll({
        search: [ACTIVE_ITEMS],
        limit: LIMIT_ITEMS_SELECT,
      });
    },
  });

  const handleChange = (segmentMarketCode: number) => {
    if (segmentMarketCode === ('all' as unknown as number)) {
      onChange(null);
      return;
    }

    const currentValues = value ?? [];
    const newValues = currentValues.includes(segmentMarketCode)
      ? currentValues.filter(id => id !== segmentMarketCode)
      : [...currentValues, segmentMarketCode];

    onChange(newValues.length > 0 ? newValues : null);
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <Box
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink> Segments Market </InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={!value}
                  onChange={() => handleChange('all' as unknown as number)}
                  sx={{ mr: 1 }}
                />
              }
              label={t('list.filter.all')}
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {(data || [])?.map(segmentMarketCode => (
              <FormControlLabel
                key={segmentMarketCode.id}
                control={
                  <Checkbox
                    checked={value?.includes(+segmentMarketCode.id!) ?? false}
                    onChange={() => handleChange(+segmentMarketCode.id!)}
                    sx={{ mr: 1 }}
                  />
                }
                label={segmentMarketCode.name}
                sx={{ py: 0.5, pl: 1.5 }}
              />
            ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
